const hash = (s) => {
  let hash = 0
  let char
  for (let i = 0; i < s.length; i++) {
    char = s.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash |= 0 // convert to i32
  }
  return hash + 0x7FFFFFFF
}

const random = (s) => {
  return (Math.random().toString(16) + '000000000').substr(2, 8)
}

const generateTID = (name, token) => {
  return [name, random(), (token ? hash(token) : 'anonymous')].join('-')
}

export const TransactionHeaderName = 'X-Transaction'

const TransactionModule = {
  namespaced: true,
  state: {
    transactionId: { }
  },
  mutations: {
    createTransactionId (state, name = '') {
      name = name || '_'
      if (state.transactionId[name]) return state.transactionId[name] // reuse old one, if available

      const accessToken = this.getters?.accessToken
      state.transactionId[name] = generateTID(name, accessToken)
    },
    resetTransactionId (state, name = '') {
      name = name || '_'

      const accessToken = this.getters?.accessToken
      state.transactionId[name] = generateTID(name, accessToken)
    },
    removeTransactionId (state, name = '') {
      delete state.transactionId[name || '_']
    },
    updateAccessTokenHash (state, name = '') {
      name = name || '_'
      const accessToken = this.getters?.accessToken
      const token = state.transactionId[name]
      if (token) {
        const parts = token.split('-')
        state.transactionId[name] = [name, parts[1], (accessToken ? hash(accessToken) : 'anonymous')].join('-')
      } else {
        state.transactionId[name] = generateTID(name, accessToken)
      }
    }
  },
  getters: {
    transactionIds: state => {
      return state.transactionId
    },
    transactionId: (state, name) => {
      return state.transactionId[name] || null
    }
  },
  actions: {
    createTransactionId ({ commit }, name) {
      commit('createTransactionId', name)
    },
    removeTransactionId ({ commit }, name) {
      commit('removeTransactionId', name)
    },
    updateAccessTokenHash ({ commit }, name) {
      commit('updateAccessTokenHash', name)
    }
  }
}

export {
  TransactionModule
}
